<template>
  <!-- Begin page content -->
  <div class="row page-content">
    <div class="col-md-8 col-md-offset-2">
      <profile-banner></profile-banner>
      <router-view v-slot="slotProps">
        <component :is="slotProps.Component"></component>
      </router-view>
    </div>
  </div>
</template>

<script>
import ProfileBanner from "@/components/ProfileBanner.vue";

export default {
  components: {
    ProfileBanner,
  },
};
</script>